import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MobileTabsModel } from './mobile-tabs.model';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';

@Component({
    selector: 'fi-mobile-tabs',
    templateUrl: './mobile-tabs.component.html',
    styleUrls: ['./mobile-tabs.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class MobileTabsComponent {
    @Input() tabsModel: MobileTabsModel;

    constructor(private detectDevice: DetectDevicesService) {
        // FI-2025 Home tab should be highlighted when viewing home feed
        // mat-tabs bug, https://github.com/angular/material2/issues/6130
        if (this.detectDevice.isMobilePhone()) {
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, 100);
        }
    }

    // todo: implement swipe !!!
}
